import { Component, Input } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';

@Component({
    selector: 'registration-details',
    template: `
        <div fxLayout="column" ngModelGroup="user">
            <div fxLayout="row" fxLayoutAlign="space-around center">
                <h2>Complete Registration</h2>
            </div>
            <div *ngIf="collectNames" fxLayout="row" fxLayoutAlign="space-between center">
                <div fxLayout="column" fxLayoutAlign="space-around start" style="padding-right: 10px;">
                    <mat-form-field style="height:60px;">
                        <input  matInput
                                type="text"
                                placeholder="First Name"
                                name="firstName"
                                minlength="2"
                                ngModel
                                #firstNameCtrl="ngModel"
                                required>
                        <mat-error *ngIf="firstNameCtrl.errors?.required">First Name cannot be blank</mat-error>
                    </mat-form-field>
                </div>

                <div fxLayout="column">
                    <mat-form-field style="height:60px;">
                        <input  matInput
                                type="text"
                                placeholder="Last Name"
                                name="lastName"
                                ngModel
                                #lastNameCtrl="ngModel"
                                required>
                        <mat-error *ngIf="lastNameCtrl.errors?.required">Last Name cannot be blank</mat-error>                                
                    </mat-form-field>
                </div>
            </div>
            <div fxLayout="row" fxLayoutAlign="space-between start">
                <div fxLayout="column" style="padding-right: 10px;" fxFlex="50">
                    <mat-form-field style="height:60px;">
                        <input  matInput
                                type="password"
                                placeholder="Password"
                                name="password"
                                ngModel
                                validateEqual="confirmPassword" 
                                reverse="true"
                                #passwordCtrl="ngModel"
                                required
                                pattern="^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$">
                        <mat-error *ngIf="passwordCtrl.errors?.required">Password cannot be blank</mat-error>
                        <mat-error *ngIf="passwordCtrl.errors?.pattern">Password must contain at least one upper case letter, one lowercase letter, one number and be at least 8 characters long.</mat-error>
                    </mat-form-field>
                </div>
                <div fxLayout="column" fxFlex="50">                            
                    <mat-form-field style="height:60px;">
                        <input  matInput
                                type="password"
                                placeholder="Confirm Password"
                                name="confirmPassword"
                                ngModel
                                validateEqual="password" 
                                reverse="false"
                                #confirmPasswordCtrl="ngModel"
                                (focus)="confirmPasswordCtrl.control.markAsTouched()">
                        <mat-error *ngIf="confirmPasswordCtrl.errors?.validateEqual">Passwords do not match.</mat-error>
                    </mat-form-field>
                </div>
            </div>
        </div>
    `,
    viewProviders: [ { provide: ControlContainer, useExisting: NgForm } ]
})
export class RegistrationDetailsComponent {
    // @Input() user: {firstName?, lastName?, password?, confirmPassword?} = {};
    @Input() collectNames = true;
}
